<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">卡管理</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 顶部tab 开始 -->
    <div class="page_tab">
      <div class="page_tablist" v-for="(item,index) in tabs" @click="handleItemTap(index)">
        <div :class="item.isActive ? 'page_tabname':'page_tabname1'">{{item.value}}</div>
      </div>
    </div>
    <!-- 顶部tab 结束 -->
    <div v-if="tabsindex == 0" class="banklistbox">
      <div v-for="(item,index) in bankList " :key="index" @click=" buttonClicked ? '' : taplist(index) " id="binkCardIndexChange"
        class="tixian_zhanghuList1">
        <div class="tixian_zhanghutop">
          <div>{{ item.bank }}</div>
          <div class="greyColor">{{ item.card_no }}</div>
        </div>
        <div @click.stop="tapyi(index)" id="alipayIndexDelete" class="tixian_zhanghudel">
          <img src="/static/newprojecticon/del.png" class="tixian_delimg" />
        </div>
      </div>
      <div class="zhanghuList1" @click="toaddbank">
        <div class="zhanghuName">添加银行卡</div>
        <img src="/static/xiangyou.png" class="zhanghuselect" />
      </div>

    </div>
    <div v-if="tabsindex == 1">
      <div v-for="(item,index) in alipayList " :key="index" @click=" buttonClicked ? '' : taplist1(index) " id="alipayIndexChange"
        class="tixian_zhanghuList1">
        <div class="tixian_zhanghutop">
          <div>{{ item.name }}</div>
          <div class="greyColor">{{ item.account }}</div>
        </div>
        <div @click.stop="tapzhi(index)" id="alipayIndexDelete" class="tixian_zhanghudel">
          <img src="/static/newicon/shanchuicon.png" class="tixian_delimg" />
        </div>
      </div>
      <div class="zhanghuList1" @click="toaddbank">
        <div class="zhanghuName">添加支付宝账号</div>
        <img src="/static/xiangyou.png" class="zhanghuselect" />
      </div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        tabs: [{
          value: "银行卡",
          isActive: true
        }, {
          value: "支付宝",
          isActive: false
        }],
        tabsindex:0,
        alipayList: [], //支付宝列表
        bankList: [], //银行卡列表
      }
    },
    created() {
      this.request("getAlipayList")
      this.request("getBinkCardList")
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //tabs点击事件
      handleItemTap(index) {
        let that = this
        let tabs = this.tabs
        tabs.forEach((v, i) => i === index ? v.isActive = true : v.isActive = false)
        that.tabs = tabs
        that.tabsindex = index
      },
      //跳转新增账户页面
      toaddbank() {
        this.$router.push({
          path: '/addbank',
          query: {
            tabsid: this.tabsindex
          }
        })
      },
      //删除银行卡
      tapyi(e) {
        let that = this
        this.show = false
        Dialog.confirm({
            title: '提示',
            message: '确认删除银行卡指定账户',
          })
          .then(() => {
            let idi = that.bankList[Number(e)].id //动态获取删除该条数据的id

            let requestData = {
              id: idi
            }
            that.request('delBinkCard', requestData)
            that.bankList.splice(Number(e), 1)
            if (that.bankList.length && that.bankList.every(item => item.checked === false)) that.bankList[
              0].checked = true
            let bankList1 = that.bankList
            that.bankList = bankList1
            return
          })
          .catch(() => {
            return false;
          });
      },
      tapzhi(e) {
        let that = this
        this.show = false
        Dialog.confirm({
            title: '提示',
            message: '确认删除支付宝指定账户',
          })
          .then(() => {
            let idi = that.alipayList[Number(e)].id //动态获取删除该条数据的id
            let requestData = {
              id: idi
            }
            that.request('delAlipay', requestData)
            that.alipayList.splice(Number(e), 1)
            if (that.alipayList.length && that.alipayList.every(item => item.checked === false)) that.alipayList[0]
              .checked = true
            let alipayList1 = that.alipayList
            that.alipayList = alipayList1
          })
          .catch(() => {
            return false;
          });
      },

      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          // 获取支付宝账号列表
          case 'getAlipayList':
            httper.get('user/alipay-list', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                //res.data.map((item, index) => item.checked = index === that.oilCardIndex)
                that.alipayList = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            //获取银行卡列表
          case 'getBinkCardList':
            httper.get('user/bank-card-list', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                that.bankList = res.data
              //   res.data.map((item, index) => item.checked = index === that.oilCardIndex)
              //   that.bankList = res.data
              //   that.carnumlast = res.data[that.oilCardIndex] ? res.data[that.oilCardIndex].card_no.substr(-4) : ''

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            // 删除支付宝列表
          case 'delAlipay':
            httper.get('user/del-alipay', requestData, res => {
              if (res.code === 0) {
                // 初始化数据

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            // 删除银行卡列表
          case 'delBinkCard':
            httper.get('user/del-bank-card', requestData, res => {
              if (res.code === 0) {
                // 初始化数据

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .banklistbox{
    width: calc(100% - 40px);
    margin: 20px;
  }
  .tixian_zhanghuList {
    /* position: relative; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
  }
  .tixian_zhanghuList1 {
    /* position: relative; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E5E5;
  }

  .tixian_zhanghutop {}

  .tixian_zhanghudel {}

  .tixian_delimg {
    width: 30px;
    height: 30px;
  }
  .zhanghuList1 {
  /*  height: 30px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #d6d6d6;
  }

  .zhanghuName {}

  .zhanghuselect {
    width: 20px;
    height: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/mine/banklist.vue